import { Link } from "react-router-dom";

import { usePublicConfig } from "../api/usePublicConfig";

export function Landing() {
  const config = usePublicConfig();

  return (
    <main className="page">
      <h1>Tekdi Apply</h1>
      <p>
        A ~25-minute screening round for early-career applicants. You'll connect your own AI agent,
        let it fill your profile from your CV, and then answer three short thinking questions
        yourself. There is no code to write.
      </p>
      <p>
        <Link className="button" to="/consent">
          Start
        </Link>
      </p>
      {config.isError && (
        <p role="alert">We couldn't reach the server. Please try again shortly.</p>
      )}
    </main>
  );
}
